import React from "react";
import PropTypes from "prop-types";

import Item from "./Item";

const List = ({ data, onDelete, onRemove, onSave }) => (
  <table className="table table-clean">
    <thead>
      <tr>
        <th>Status</th>
        <th />
      </tr>
    </thead>

    <tbody>
      {data.length === 0 ? (
        <tr>
          <td colSpan={2}>No shift statuses</td>
        </tr>
      ) : (
        data.map(item => (
          <Item
            key={item.id || item._id}
            data={item}
            onDelete={onDelete}
            onRemove={onRemove}
            onSave={onSave}
          />
        ))
      )}
    </tbody>
  </table>
);

List.propTypes = {
  data: PropTypes.array.isRequired,
  onDelete: PropTypes.func,
  onRemove: PropTypes.func,
  onSave: PropTypes.func
};

export default List;
